module.exports = __webpack_public_path__ + "static/media/certificate_flc.9e6f14fa.png";